module.exports = __webpack_public_path__ + "assets/low-fuel.dea0a82f.svg";